import { isNumberLiteral } from "@babel/types";
/*
, {
    name: 'm:tel',
    index: 2,
    productType: 1,
    amounts: [2, 5, 10, 20, 50]
}

, {
    name: 'happy',
    productType: 1,
    index: 6,
    amounts: [2, 5, 10, 20, 50]
}

 */
const operatorsOld = [{
    name: 'BHTelecom',
    index: 3,
    productType: 1,
    amounts: [2, 5, 10, 20, 50]
}, {
    name: 'Eronet',
    index: 1,
    productType: 1,
    amounts: [2, 5, 10, 15, 20, 25, 50]
},
{
    name: 'm:tel',
    index: 2,
    productType: 1,
    amounts: [2, 5, 10, 20, 50]
},
{
    name: 'haloo',
    productType: 1,
    index: 4,
    amounts: [2, 5, 10, 20, 50]
}, {
    name: "xBon",
    productType: 2,
    voucherType: 1,
    index: 8

}, {
    name: "KLIKER",
    productType: 2,
    voucherType: 2,
    index: 13
}
];

const operators = [{
    name: 'BHTelecom',
    index: 3,
    productType: 1,
    amounts: [2, 5, 10, 20, 50]
}, {
    name: 'Eronet',
    index: 1,
    productType: 1,
    amounts: [2, 5, 10, 15, 20, 25, 50]
}, {
    name: 'haloo',
    productType: 1,
    index: 4,
    amounts: [2, 5, 10, 20, 50]
}
];


const deliveryTypes = [{
    name: "Premijer Članski broj",
    index: 1
}, {
    name: "Email",
    index: 2
}
];


export const initState = {
    operators: operators,
    deliveryTypes: deliveryTypes,
    phoneNumber: "",
};

export function reducer(state, action) {

    switch (action.type) {

        case "setUsernameSurname":
            return {
                ...state,
                usernameSurname: action.payload
            };

        case "email":
            return {
                ...state,
                deliveryType: 2,
                email: action.payload
            };


        case "membershipNumber":
            return {
                ...state,
                membershipNumber: action.payload
            };


        case "deliveryType":
            let deliveryType = state.deliveryTypes.find(item => item.name == action.payload);
            return {
                ...state,
                deliveryType
            };

        case "redirectTo":
            return {
                ...state,
                redirectTo: action.payload.url,
                redirectMethod: action.payload.method,
                redirectParams: action.payload.params
            };

        case "selectIntervalAmount":
            //console.log("action.payload", action.payload);
            if (action.payload && !isNaN(action.payload) && Number.isSafeInteger(Number(action.payload))
                && !action.payload.includes(".")) {
                //console.log("it is number", action.payload);
                let amount = Number(action.payload.replace(/\./g, ""));
                if (1 <= amount && amount <= 200) {
                    return {
                        ...state,
                        amount
                    };
                } else {
                    //console.log("out of range", action.payload);
                    return {
                        ...state
                    };
                }

            } else if (action.payload === "") {
                //console.log("it is not number", action.payload);
                //console.log("it is not number", action.payload.length);
                return {
                    ...state,
                    amount: ""
                };
            } else {
                //console.log("it is not number2", action.payload);
                return {
                    ...state
                };
            }


        case "selectAmount":
            return {
                ...state,
                amount: Number(action.payload)
            };

        case "phoneNumberSelected":
            if (isValidPhoneNumber(action.payload)) {
                return {
                    ...state,
                    phoneNumber: action.payload
                };
            } else {
                return state;
            }


        case "selectOperatorByName":
            let operator = state.operators.find(item => item.name == action.payload);

            if (operator) {
                return {
                    ...state,
                    selectedOperator: operator,
                    operatorAmounts: operator.amounts,
                    deliveryType: undefined
                }
            } else {
                return state;
            }

        default:
            return state;

    }

}


function isValidPhoneNumber(phoneNumber) {
    return phoneNumber && /^\d+$/.test(phoneNumber) || phoneNumber == ""
}
